<template>
    <div>
        <nav class="breadcrumb bg-white push">
            <a class="breadcrumb-item" href="javascript:void(0)">Dashboard</a>
            <span class="breadcrumb-item active">Setting</span>
        </nav>

        <div class="block-content">
            <div class="row">
                <button
                    type="button"
                    class="btn btn-info text-white mr-5 mb-5"
                    @click.prevent="newModal"
                >
                    <i class="fa fa-plus mr-5"></i> Update Rates
                </button>
            </div>
            <hr />
            <div class="row">
                <div class="col-sm-12 table-responsive">
                    <table
                        class="table table-bordered table-striped table-vcenter js-dataTable-simple dataTable no-footer"
                        id="DataTables_Table_0"
                        role="grid"
                        aria-describedby="DataTables_Table_0_info"
                    >
                        <thead>
                            <tr role="row">
                                <th>
                                    #
                                </th>

                                <th class="text-capitalize">Name</th>
                                <th class="text-capitalize">Rate</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr
                                role="row"
                                class="odd"
                                v-for="(setting, index) in filteredSettings"
                                :key="setting.id"
                            >
                                <td>
                                    {{ index + 1 }}
                                </td>
                                <td>
                                    {{ setting.name }}
                                </td>
                                <td>
                                    {{ setting.value }}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>

        <div
            class="modal fade"
            id="modal-fadein"
            tabindex="-1"
            role="dialog"
            aria-labelledby="modal-fadein"
            style="display: none;"
            aria-hidden="true"
        >
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h3 class="card-title">Add New Setting</h3>
                        <button
                            type="button"
                            class="close"
                            data-dismiss="modal"
                            aria-label="Close"
                        >
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <!-- Beginning of the form -->
                    <form @submit.prevent="setSetting">
                        <div class="modal-body">
                            <div class="card">
                                <div class="card-body">
                                    <div class="form-group">
                                        <label for="name" class="text-muted"
                                            >Name</label
                                        >
                                        <select
                                            class="form-control"
                                            v-model="form.name"
                                        >
                                            <option
                                                value="LOCAL_TRANSFER_CHARGE"
                                            >
                                                Local Transfer Charge
                                            </option>
                                            <option
                                                value="DOMESTIC_TRANSFER_CHARGE"
                                            >
                                                Domestic Transfer Charge
                                            </option>
                                            <option
                                                value="INTERNATIONAL_TRANSFER_CHARGE"
                                            >
                                                International Transfer Charge
                                            </option>
                                        </select>
                                    </div>
                                    <div class="form-group">
                                        <label for="name" class="text-muted"
                                            >Value</label
                                        >
                                        <input
                                            v-model="form.value"
                                            type="text"
                                            class="form-control"
                                            id="name"
                                            required
                                        />
                                    </div>
                                    <button
                                        :disabled="processing"
                                        type="submit"
                                        class="btn btn-lg btn-outline-success mb-2"
                                    >
                                        {{
                                            processing ? "processing" : "Create"
                                        }}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { RepositoryFactory } from "../../../repository/RepositoryFactory";

const UsersRepository = RepositoryFactory.get("users");
export default {
    data() {
        return {
            settings: [],
            processing: false,
            coinpayment: "",
            form: new Form({
                id: "",
                name: "LOCAL_TRANSFER_CHARGE",
                value: "",
                public: "",
                private: ""
            })
        };
    },
    methods: {
        newSetUp() {
            this.editmode = false;
            this.form.reset();
            $("#modal-fadein2").modal("show");
        },
        setUp() {
            this.$Progress.start();
            let data = {
                name: this.form.name,
                public: this.form.public,
                private: this.form.private
            };
            this.processing = true;
            UsersRepository.coinpaymentSetUp(data)
                .then(response => {
                    this.processing = false;
                    $("#modal-fadein2").modal("hide");
                    toast.fire({
                        type: "success",
                        title: "Setup successful"
                    });
                    this.$Progress.finish();
                    Fire.$emit("Refresh");
                })
                .catch(error => {
                    this.processing = false;
                    if (error.response.status == 403) {
                        toast.fire({
                            type: "error",
                            title: "Action Unauthorized"
                        });
                    } else
                        toast.fire({
                            type: "warning",
                            title: "Failed to create setting"
                        });
                });
        },
        newModal() {
            this.editmode = false;
            this.form.reset();
            $("#modal-fadein").modal("show");
        },
        editModal(setting) {
            this.editmode = true;
            this.form.reset();
            $("#modal-fadein").modal("show");
            this.form.fill(setting);
        },
        settingDelete(id, setting) {
            swal.fire({
                title: "Are you sure?",
                text: "You won't be able to revert this!",
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: "Yes, delete it!"
            }).then(result => {
                // Send request to the server
                if (result.value) {
                    UsersRepository.deleteSetting(id)
                        .then(response => {
                            const settingIndex = this.settings.findIndex(
                                p => p.id === setting.id
                            );
                            this.settings.splice(settingIndex, 1);
                            swal.fire(
                                "Deleted!",
                                response.data.message,
                                response.data.status
                            );
                        })
                        .catch(error => {
                            if (error.response.status == 403) {
                                toast.fire({
                                    type: "error",
                                    title: "Action Unauthorized"
                                });
                            } else
                                swal(
                                    "Failed!",
                                    "There was something wrong.",
                                    "warning"
                                );
                        });
                }
            });
        },
        setSetting() {
            this.processing = true;
            let data = {
                name: this.form.name,
                value: this.form.value
            };
            UsersRepository.createSetting(data)
                .then(response => {
                    this.settings = response.data;
                    $("#modal-fadein").modal("hide");
                    this.processing = false;
                    toast.fire({
                        type: "success",
                        title: "Setting created successfully"
                    });
                    this.$Progress.finish();
                    Fire.$emit("Refresh");
                })
                .catch(error => {
                    this.processing = false;
                    if (error.response.status == 403) {
                        toast.fire({
                            type: "error",
                            title: "Action Unauthorized"
                        });
                    } else
                        toast.fire({
                            type: "warning",
                            title: "Failed to create setting"
                        });
                });
        },
        loadSettings() {
            UsersRepository.viewSettings().then(response => {
                this.settings = response.data;
            });
        }
    },
    created() {
        this.loadSettings();
        Fire.$on("Refresh", () => {
            this.loadSettings();
        });
    },
    computed: {
        filteredSettings() {
            return this.settings.filter(rate => rate.id < 4);
        }
    }
};
</script>
